import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Heading extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { upTitle, title, uppercase } = this.props;

    return (
      <header className="heading">
        <p className="heading_up">{ uppercase ? upTitle.toUpperCase() : upTitle }</p>
        <h2 className="heading_title">{ uppercase ? title.toUpperCase() : title }</h2>
      </header>
    )
  }
}
Heading.defaultProps = {
  upTitle: '',
  title: '',
  uppercase: false
}

Heading.propTypes = {
  upTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  uppercase: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Heading.js